<template>
  <div class="pack-name" :class="packClass">
    <img :src="packIcon" alt="pack-icon" />
    <span class="pack-name__text">
      {{ $t(`suscriptions.names.${packName}`) }}
    </span>
  </div>
</template>

<script>
// Utilities
import { slugify } from 'Utils'

export default {
  name: 'PackName',

  props: {
    packName: {
      type: String,
      required: true,
    },

    packIcon: {
      type: String,
      required: true,
    },
  },

  computed: {
    packClass() {
      return slugify(this.packName)
    },
  },
}
</script>

<style scoped>
.pack-name {
  display: flex;
  align-items: center;
  position: relative;
  width: max-content;
  color: var(--c-primary);
  right: 0;
  left: 0;
  top: -12px;
  margin: 0 auto;
  padding: 0 11px;
  background-color: #fff;
  z-index: 1;
}

.pack-name.no-suscription {
  top: -15px;
}

.pack-name__text {
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-transform: capitalize;
}

.pack-name__text:first-letter {
  text-transform: uppercase;
}

.pack-name img {
  width: 30px;
  margin-right: 10px;
}

.pack-name.modo-turbo img {
  width: 20px;
}
</style>
